import { render, staticRenderFns } from "./boardStatistic.vue?vue&type=template&id=629806f1&scoped=true&"
import script from "./boardStatistic.vue?vue&type=script&lang=js&"
export * from "./boardStatistic.vue?vue&type=script&lang=js&"
import style0 from "./boardStatistic.vue?vue&type=style&index=0&id=629806f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629806f1",
  null
  
)

export default component.exports